import apiClient from './api-client';

export interface DistributionRow {
  category: string;
  outstanding_balance: string;
  pct_of_portfolio: string;
  wa_price: string | null;
  wa_benchmark_yield: string;
  wa_credit_spread: string;
  wa_market_yield: string;
  wal: string;
  modified_duration: string;
  loan_count: number;
  total_npv: string | null;
}

interface Distribution {
  title: string;
  rows: DistributionRow[];
  total: DistributionRow;
}

export interface PortfolioStatistics {
  total_outstanding_balance: string;
  min_price: string;
  max_price: string;
  avg_price: string;
  avg_benchmark_yield: string;
  avg_credit_spread: string;
  avg_market_yield: string;
  avg_wal: string;
  min_wal: string;
  max_wal: string;
  avg_modified_duration: string;
  min_modified_duration: string;
  max_modified_duration: string;
  total_loan_count: number;
}

export interface DashboardAnalytics {
  portfolio_statistics: PortfolioStatistics;
  sector_distribution: Distribution;
  leverage_distribution: Distribution;
  loan_status: Distribution;
  maturity_distribution: Distribution;
  property_lifecycle: Distribution;
  amortization_type: Distribution;
  location_distribution: Distribution;
  interest_type_distribution: Distribution;
}

export const dashboardService = {
  async getDashboardAnalytics(): Promise<DashboardAnalytics> {
    const response = await apiClient.get('/api/v1/dashboard/analytics');
    return response.data;
  },
};

export default dashboardService;
